import Button from '../../../components/base/Button';

const WebdesignCTA = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-32 bg-zinc-950 relative overflow-hidden">
      {/* Ambient Background */}
      <div className="absolute inset-0 bg-gradient-radial from-[#d1bc8a]/10 via-transparent to-transparent opacity-50"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center space-x-3 mb-8">
            <div className="w-2 h-2 bg-[#d1bc8a] rounded-full"></div>
            <span className="text-sm uppercase tracking-[0.3em] text-gray-500 font-light">Bereit zu starten?</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-8 tracking-tight leading-[1.1]">
            Lassen Sie uns Ihre<br />
            <span className="text-[#d1bc8a]">Vision verwirklichen</span>
          </h2>
          
          <p className="text-lg md:text-xl text-gray-400 mb-12 max-w-2xl mx-auto font-light leading-relaxed">
            Kontaktieren Sie uns für ein unverbindliches Beratungsgespräch. 
            Gemeinsam entwickeln wir die perfekte Website für Ihr Unternehmen.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Button
              onClick={scrollToContact}
              className="px-10 py-4 bg-[#d1bc8a] text-black font-medium rounded-none hover:bg-white transition-all duration-300 cursor-pointer whitespace-nowrap text-sm tracking-wider uppercase"
            >
              Jetzt Kontakt aufnehmen
            </Button>

          </div>


        </div>
      </div>
    </section>
  );
};

export default WebdesignCTA;